import { formatNumber } from '../../../utils/formatNumber'

type StatsTableProps = {
  data: Array<{
    averageCo2PerCar: number
    averageNoxPerCar: number
  }>
}

function StatsTable({ data }: StatsTableProps) {
  const stats = data[0]

  if (!stats) return null

  const settings = {
    digits: { min: 0, max: 0 },
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <h3 className="text-lg font-medium text-primaryText mb-4">Statistikk</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex flex-col">
          <span className="text-sm text-secondaryText mb-1">Gjennomsnittlig CO2 per bil</span>
          <span className="text-xl font-semibold text-primaryText">
            {formatNumber(stats.averageCo2PerCar, settings)} kg
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-sm text-secondaryText mb-1">Gjennomsnittlig NOX per bil</span>
          <span className="text-xl font-semibold text-primaryText">
            {formatNumber(stats.averageNoxPerCar, settings)} g
          </span>
        </div>
      </div>
    </div>
  )
}

export default StatsTable
